import type { Signup } from "@/users/types";
import { apiClient } from "./apiClient";

export const signupGateway = {
  async createSignup(signup: Signup): Promise<void> {
    return await apiClient.post("/api/users/signup", signup);
  },
};
